import React from 'react';
//import {Link} from 'react-router-dom';
//import NoPropertyPhoto from '../img/no-property-photo.png';
//import {getFormattedCurrency} from '../components/utils';
//import {ImageRewrite} from '../components/util.js';
//import { Carousel } from 'react-responsive-carousel';
//import 'react-responsive-carousel/lib/styles/carousel.min.css';
//import 'intersection-observer'; // optional polyfill
//import Observer from '@researchgate/react-intersection-observer';
import ListingCard from './listingCard';

class MapPopup extends React.Component {

    getCurrentPropertyContent = () => {
        var currProperty = null;
        if(this.props.property){
            currProperty = this.props.property;
        }

        if(!currProperty) return null;

        return (
            <div className="property_popup">
                <ListingCard listingActions={this.props.listingActions} onCommentsClick={this.props.onCommentsClick} onClick={this.props.onCommentsClick} listing={currProperty} isMapPopup={true} isMobile={this.props.isMobile} history={this.props.history}></ListingCard>
            </div>
        );
    }

    render() {
        return (
            <div className="property_popup_wrapper">
                {this.getCurrentPropertyContent()}
            </div>
        )
    }
}

export default MapPopup;